/**
 * AnnouncementTagLookupService
 * Service for managing announcement tag lookup values
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for announcement tag lookup CRUD operations
 */
export class AnnouncementTagLookupService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AnnouncementTagLookupService.DEFAULT_SERVICE_PATH,
            basePath: AnnouncementTagLookupService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
AnnouncementTagLookupService.DEFAULT_SERVICE_PATH = 'announcements';
AnnouncementTagLookupService.BASE_PATH = 'api/announcement-tag-lookup';
//# sourceMappingURL=AnnouncementTagLookupService.js.map